export const ARMSTRONG_V1 = 'armstrong_v1';
export const EP_MOBILE_EDIT = 'ep_mobileEdit';
